import { neutral } from '@bloomfieldrobotics/canopy';
import { Paper, styled, Typography } from '@mui/material';
import { useAxesTooltip } from '@mui/x-charts/ChartsTooltip';
import { StageCountDatasetValue } from '../../../../blocks/BlockPointsMap/controls/StageDataDisplay/types';
import { StagesCountDataDisplay } from '../../../blueberry/components/StagesCountDataDisplay';

type BarChartTooltipProps = {
  totalLabel?: string;
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: theme.vars.palette.background.default,
  border: '1px solid',
  borderColor: neutral[750],
  padding: theme.spacing(4),
}));

export const BarChartTooltip = ({
  totalLabel = 'Total',
}: BarChartTooltipProps) => {
  const tooltipData = useAxesTooltip();

  const firstAxisData = tooltipData?.at(0);
  if (!firstAxisData) {
    return null;
  }

  const blockName = firstAxisData.axisFormattedValue;

  const dataset: StageCountDatasetValue[] = firstAxisData.seriesItems
    .map((item, index) => ({
      id: String(item.seriesId),
      label: item.formattedLabel || '',
      value: typeof item.value === 'number' ? item.value : 0,
      color: item.color,
      order: index,
    }))
    .filter((item) => item.value > 0);

  const totalCount = dataset.reduce((sum, d) => sum + d.value, 0);

  return (
    <StyledPaper>
      {blockName && (
        <Typography
          variant='body2'
          sx={{
            fontWeight: 600,
            mb: 1,
          }}
        >
          {blockName}
        </Typography>
      )}
      <StagesCountDataDisplay
        dataset={dataset}
        totalLabel={totalLabel}
        totalCount={totalCount}
        variant='compact'
      />
    </StyledPaper>
  );
};
